import { endpoints } from "../../../../ApiEndPoints/apiEndPoints";
import { UI_CONSTANTS } from "../../../../Constants/constants";
import { IRequestParams } from "../../../../Interfaces/IRequestParams";
import { RequestMethodType } from "../../../../Redux/Types/types";
import { filterPayloadType } from "../../../../Types/filterPayloadType";
import { SearchMethodsvalues, SearchOperatorsvalues } from "../../../../Types/oDataQueryTypes";

export const serviceForGetApi = (params: IRequestParams, filterPayload: Readonly<Pick<filterPayloadType, "codeScreen" | "isDirectQuery" | "nestedSearchId">>): string => {
    if (params.service.includes("Volumetrics")) {
        return params.service;
    }

    const { codeScreen, isDirectQuery, nestedSearchId } = filterPayload;
    const shouldUseProductData = (!params.filter || codeScreen === UI_CONSTANTS.DASHBOARD);

    if (isDirectQuery || nestedSearchId !== undefined) {
        return shouldUseProductData ? endpoints.getProductData() : endpoints.searchProductIndex();
    }

    return endpoints.getProductData();
};

export const methodForGetApi = (params: IRequestParams, filterPayload: Readonly<Pick<filterPayloadType, "codeScreen" | "isDirectQuery" | "nestedSearchId">>): RequestMethodType => {
    const { codeScreen, isDirectQuery, nestedSearchId } = filterPayload;
    const shouldUseGetMethod = (!params.filter || codeScreen === UI_CONSTANTS.DASHBOARD || params.service.includes("Volumetrics"));

    if (isDirectQuery || nestedSearchId !== undefined) {
        return shouldUseGetMethod ? "get" : "search";
    }

    return "get";
};

export const formatFilterQueryString = (filter: string, parentName: string | undefined, selectedMenu: string | undefined, service: string): string => {

    if (!filter?.trim()) {
        return filter;
    }

    if (parentName === "/product" && selectedMenu === "Food Volumetrics") {
        const filterFields: Array<string> = [
            'DCP',
            'SuperCatDesc',
            'SkuNo',
            'SuppCode',
            'SuppName',
            'OfficeDesc',
            'Desc',
            'FileName'
        ];

        const searchValue = filter.toLowerCase();
        const containsFilterConditions: Array<string> = filterFields.map(field => `${SearchMethodsvalues.CONTAINS}(tolower(${field}), '${searchValue}')`);

        return containsFilterConditions.join(` ${SearchOperatorsvalues.OR} `);
    }

    return service.includes('Volumetrics') ? "" : filter;
};